var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint consistent-return: 0 */

import isString from 'lodash/isString';
import merge from 'lodash/merge';

import deviceDefaults from './device-defaults';

export function sdrn(id) {
  return 'sdrn:schibsted:environment:' + id;
}

/**
 * Device Input
 *
 * The values in `id` and `additionalIds` will be transformed to a valid ID
 * according to schema. Other values are passed on as is.
 */

/**
 * A correct schema representation of a Device
 */


function formatDeviceInput(input) {
  if (isString(input)) {
    return { id: input };
  }

  var _ref = input || {},
      id = _ref.id,
      rest = _objectWithoutProperties(_ref, ['id']);

  return _extends({ id: id }, rest);
}

/**
 * Generate a device representation
 *
 * Several default values are used in a browser environment: acceptLanguage,
 * screenSize, userAgent, deviceType, viewportSize, localStorageEnabled. See
 * (device-browser.js)[device-browser.js] for implementation details.
 *
 * The browser implementation will also read the required values from the
 * `_pulse2cookie` and if needed sync with CIS. Note that *this is not
 * implemented for Node.js environments*. There are no default values in
 * Node.js.
 */
export default function device(data) {
  var _ref2 = data || {},
      deviceData = _ref2.device;

  var defaults = deviceDefaults();
  var input = merge({}, defaults, formatDeviceInput(deviceData));

  var id = input.id,
      additionalIds = input.additionalIds,
      props = _objectWithoutProperties(input, ['id', 'additionalIds']);

  if (!id) {
    return undefined;
  }
  var baseDevice = {
    '@type': 'Device',
    environmentId: sdrn(id)
  };
  if (additionalIds) {
    baseDevice.additionalEnvironmentIds = additionalIds.map(sdrn);
  }
  return Object.assign(baseDevice, props);
}

export var defaultValue = deviceDefaults;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-event-builders/dist/ejs/_device.js
// module id = 526
// module chunks = 0